import React from 'react';

export default function Plus(props: any) {
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 12C4.84375 12 2.875 10.875 1.79688 9C0.71875 7.14844 0.71875 4.875 1.79688 3C2.875 1.14844 4.84375 0 7 0C9.13281 0 11.1016 1.14844 12.1797 3C13.2578 4.875 13.2578 7.14844 12.1797 9C11.1016 10.875 9.13281 12 7 12ZM6.4375 8.0625C6.4375 8.39062 6.67188 8.625 7 8.625C7.30469 8.625 7.5625 8.39062 7.5625 8.0625V6.5625H9.0625C9.36719 6.5625 9.625 6.32812 9.625 6C9.625 5.69531 9.36719 5.4375 9.0625 5.4375H7.5625V3.9375C7.5625 3.63281 7.30469 3.375 7 3.375C6.67188 3.375 6.4375 3.63281 6.4375 3.9375V5.4375H4.9375C4.60938 5.4375 4.375 5.69531 4.375 6C4.375 6.32812 4.60938 6.5625 4.9375 6.5625H6.4375V8.0625Z"
        fill="currentColor"
      />
    </svg>
  );
}
